"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_head_1 = __importDefault(require("vue-head"));
var toastr_1 = __importDefault(require("toastr"));
var app_1 = __importDefault(require("./router/app"));
var app_2 = __importDefault(require("./store/app"));
var RootView_vue_1 = __importDefault(require("./components/app/RootView.vue"));
var app_3 = __importDefault(require("./http/app"));
var vue_scrollto_1 = __importDefault(require("vue-scrollto"));
Multipayment.init(process.env.MIX_GMO_SHOP_ID);
vue_1.default.prototype.$toastr = toastr_1.default;
vue_1.default.prototype.$http = app_3.default;
vue_1.default.component('root-view', RootView_vue_1.default);
vue_1.default.use(vue_head_1.default, {
    separator: '|',
    complement: '在宅看護指導士資格試験申し込み'
});
vue_1.default.use(vue_scrollto_1.default);
new vue_1.default({
    el: '#app',
    router: app_1.default,
    store: app_2.default,
});
